import React from 'react'
import './style.scss'

const Text : React.FC = () => {
    return(
        <div>
            <div><span className="text var1">HELLO!</span></div>
            <div><span className="text var2">I'M JESSI</span></div>
            <div><span className="text var3">Graphic Designer & Front End Developer</span></div>
        </div>
    )
}

export default Text